import GeneralObjectMarkHead from "../models/GeneralObjectMarkHead";
import GeneralObjectMarkItem from "../models/GeneralObjectMarkItem";
import GeneralObjectMarkTag from "../models/GeneralObjectMarkTag";
import api from "./ObjectMarkApi";

export class ObjectMarkStore {

  objectTags: GeneralObjectMarkTag[] = [];

  //---------- Item ----------//

  async loadItemObjectMarkTags(tableRelation: string, transactionId: number) { 
    return await api.getItemObjectMarkTags(tableRelation, transactionId);
  }

  async addObjectMarkTagToItem(transactionId: number, generalObjectMarkTag: GeneralObjectMarkTag) { 
    await api.addObjectMarkTagToItem(transactionId, generalObjectMarkTag);
  }
  
  async removeObjectMarkTagFromItem(objectMarkItem: GeneralObjectMarkItem) { 
    await api.removeObjectMarkTagFromItem(objectMarkItem);
  }

  async copyObjectMarkTagsToAllItems(objectMarkHeadId: number, tableRelation: string, withFullDelete: boolean) { 
    await api.copyObjectMarkTagsToAllItems(objectMarkHeadId, tableRelation, withFullDelete);
  }
    
  //---------- Tag ----------//

  async loadObjectMarkTagsByTableRelation(tableRelation: string) { 
    this.objectTags = await api.getObjectMarkTagsByTableRelation(tableRelation);
  }

  async updateObjectMarkTag(objectMarkTag: GeneralObjectMarkTag) { 
    return await api.updateObjectMarkTag(objectMarkTag);
  }
}

const store = new ObjectMarkStore();
export default store;